// extracted by mini-css-extract-plugin
export default {"dot":"TjMj9cbLPzRdagO9KJtC","placeHolderShimmer":"a9MKwS5gt1bhJJEJpbeM"};